import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import style from './AsideMenu.module.scss';

import { hasRole, Roles } from 'helpers/roles';

import { ROUTES } from 'routes/routes';

import NavigationItem from './NavigationItem';
import NavigationGroup from './NavigationGroup';

@observer
class Navigation extends Component {
  render() {
    return (
      <nav className={style.navigation}>
        <ul className={classNames(style.navigation__menu, style.menu__top)}>
          <NavigationGroup
            items={[
              hasRole([Roles.accountant, Roles.hostess]) && (
                <NavigationItem
                  key="person"
                  iconType="personIcon"
                  to={ROUTES.employees}
                >
                  <FormattedMessage id="asideMenu.item.employees.title" />
                </NavigationItem>
              ),
            ]}
          />

          <NavigationGroup
            items={[
              hasRole([Roles.service]) && (
                <NavigationItem
                  key="basket"
                  iconType="basket"
                  to={ROUTES.service}
                >
                  <FormattedMessage id="title.online.ordering" />
                </NavigationItem>
              ),
              hasRole([Roles.service]) && (
                <NavigationItem
                  key="stocklist"
                  iconType="stocklist"
                  to={ROUTES.stocklist}
                >
                  <FormattedMessage id="title.stocklist" />
                </NavigationItem>
              ),
            ]}
          />

          <NavigationGroup
            items={[
              hasRole([
                Roles.admin,
                Roles.bayerRestrictedAdmin,
                Roles.cateringAdmin,
              ]) && (
                <NavigationItem
                  key="live"
                  iconType="live"
                  to={ROUTES.admin.live}
                >
                  <FormattedMessage id="title.live" />
                </NavigationItem>
              ),
              hasRole([
                Roles.admin,
                Roles.bayerRestrictedAdmin,
                Roles.cateringAdmin,
              ]) && (
                <NavigationItem
                  key="statistic"
                  iconType="statistic"
                  to={ROUTES.admin.report}
                >
                  <FormattedMessage id="title.report" />
                </NavigationItem>
              ),
            ]}
          />

          <NavigationGroup
            items={[
              hasRole([
                Roles.admin,
                Roles.bayerRestrictedAdmin,
                Roles.cateringAdmin,
              ]) && (
                <NavigationItem
                  key="menu"
                  iconType="menu"
                  to={ROUTES.admin.menuItems}
                >
                  <FormattedMessage id="title.dishes" />
                </NavigationItem>
              ),
              hasRole([
                Roles.admin,
                Roles.bayerRestrictedAdmin,
                Roles.cateringAdmin,
              ]) && (
                <NavigationItem
                  key="schedule"
                  iconType="schedule"
                  to={ROUTES.admin.menu}
                >
                  <FormattedMessage id="title.menu" />
                </NavigationItem>
              ),
              hasRole([
                Roles.admin,
                Roles.bayerRestrictedAdmin,
                Roles.cateringAdmin,
              ]) && (
                <NavigationItem key="plu" iconType="plu" to={ROUTES.admin.plu}>
                  <FormattedMessage id="title.plu" />
                </NavigationItem>
              ),
            ]}
          />

          <NavigationGroup
            items={[
              hasRole([
                Roles.admin,
                Roles.bayerRestrictedAdmin,
                Roles.cateringAdmin,
              ]) && (
                <NavigationItem
                  key="discount"
                  iconType="discount"
                  to={ROUTES.admin.discounts}
                >
                  <FormattedMessage id="title.discounts" />
                </NavigationItem>
              ),
            ]}
          />

          <NavigationGroup
            items={[
              hasRole([Roles.admin, Roles.bayerRestrictedAdmin]) && (
                <NavigationItem
                  key="recognition"
                  iconType="recognition"
                  to={ROUTES.admin.recognition}
                  className={style.linkRecognition}
                  description={
                    <FormattedMessage id="title.recognition.description" />
                  }
                >
                  <FormattedMessage id="title.recognition" />
                </NavigationItem>
              ),
              hasRole([Roles.admin, Roles.bayerRestrictedAdmin]) && (
                <NavigationItem
                  key="meeting"
                  iconType="meeting"
                  to={ROUTES.admin.meeting}
                  className={style.linkMeeting}
                  description={
                    <FormattedMessage id="title.meeting.description" />
                  }
                >
                  <FormattedMessage id="title.meeting" />
                </NavigationItem>
              ),
            ]}
          />

          <NavigationGroup
            items={[
              hasRole([Roles.archiveAdmin]) && (
                <NavigationItem
                  key="archive"
                  iconType="archive"
                  to={ROUTES.archiveAdmin.archive}
                >
                  <FormattedMessage id="title.archive" />
                </NavigationItem>
              ),
            ]}
          />
        </ul>

        <ul className={classNames(style.navigation__menu, style.menu__bottom)}>
          {hasRole([
            Roles.admin,
            Roles.bayerRestrictedAdmin,
            Roles.cateringAdmin,
          ]) && (
            <NavigationItem iconType="settings" to={ROUTES.admin.settings}>
              <FormattedMessage id="title.settings" />
            </NavigationItem>
          )}
        </ul>
      </nav>
    );
  }
}

export default Navigation;
